import VoiceSettings from "../VoiceSettings"
import { useState } from "react"
import Button from "../ui/Button"

export default function VoiceSettingsModal({onClose, voiceSettings={}, saveTitle='Generate'}) {
    const [settings, setSettings] = useState(voiceSettings)



    return (
        <div className='h-full w-full max-w-[400px] max-h-[550px] rounded-md flex flex-col bg-background border'>
            <div className='flex-1 overflow-hidden'>
                <VoiceSettings onChange={(e)=>setSettings(e)} voiceSettings={voiceSettings} />
            </div>
            <div className='flex justify-end p-2 gap-4'>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
                <Button type='primary' className='min-w-20' onClick={() => onClose(settings)}>{saveTitle}</Button>
            </div>
        </div>
    )
}